import Vue from 'vue'
import VueI18n from 'vue-i18n'

import commonRu from '@/langs/ru.json'
import commonEn from '@/langs/en.json'
import commonUk from '@/langs/uk.json'

import mainMenuSrcRu from '@/mainMenuSrc/langs/ru.json'
import mainMenuSrcEn from '@/mainMenuSrc/langs/en.json'
import mainMenuSrcUk from '@/mainMenuSrc/langs/uk.json'

const ru = {
  ...commonRu,
  ...mainMenuSrcRu
}

const en = {
  ...commonEn,
  ...mainMenuSrcEn
}

const uk = {
  ...commonUk,
  ...mainMenuSrcUk
}

Vue.use(VueI18n)

const SUPPORTED_LOCALES = ['uk', 'ru', 'en', 'ar']
const urlLang = new URLSearchParams(location.search).get('lang')
const initialLocale = (urlLang && SUPPORTED_LOCALES.includes(urlLang))
    ? urlLang
    : (localStorage.getItem('language') || 'ru')

if (urlLang && SUPPORTED_LOCALES.includes(urlLang)) {
  localStorage.setItem('language', urlLang)
}

export const i18n = new VueI18n({
  locale: initialLocale,
  silentTranslationWarn: true,
  messages: {
    ru,
    en,
    uk
  }
})

export function setDocumentLanguage(lang) {
  const htmlLang = SUPPORTED_LOCALES.includes(lang) ? lang : 'uk'
  document.documentElement.setAttribute('lang', htmlLang)
}

export function setI18nLanguage(lang) {
  i18n.locale = lang
  localStorage.setItem('language', lang)
  setDocumentLanguage(lang)
}

setDocumentLanguage(initialLocale)
